import React from 'react';
import classnames from 'classnames';
import { IOuter } from './HorizontalSection.types';
import styles from './HorizontalSection.scss';
import { hasChildrenToRender } from '../../../utils/react/children';

export const HorizontalSection: React.FC<IOuter> = ({ children, header, className, dataHook }) => {
  if (!hasChildrenToRender(children)) {
    return null;
  }

  return (
    <div className={classnames(styles.sectionWrapper, className)} data-hook={dataHook}>
      {header && <div className={styles.header}>{header}</div>}

      <div>{children}</div>
    </div>
  );
};
